import Link from '@/_application/core/components/ui/link';
import {getCategoryUrl} from '@/_application/modules/categories/models/url';
import {CategoryTree} from '__generated__/__types__';
import cn from 'classnames';
import SidebarCategoryLevel3List from './kidsplaza-spring.desktop.sidebar-category-level-3-list';

interface IProps {
    categoryLevel2: CategoryTree;
    isHeader: boolean;
    parentLength?: number;
}

function SidebarCategoryLevel2Item({categoryLevel2, isHeader, parentLength = 0}: Readonly<IProps>) {
    return (
        <li
            className={cn(
                'group/level2 flex w-1/2 cursor-pointer flex-col justify-between gap-[10px] pl-5 text-[0.75rem] font-bold',
            )}>
            <Link href={getCategoryUrl(categoryLevel2)}>
                <p
                    className={cn('group-hover/level2:text-primary', {
                        'border-b border-solid border-KPZ_divider':
                            categoryLevel2?.children && categoryLevel2.children.length !== 0,
                    })}>
                    {categoryLevel2?.name}
                </p>
            </Link>
            {categoryLevel2?.children && categoryLevel2.children.length !== 0 && (
                <SidebarCategoryLevel3List
                    parentLength={parentLength}
                    categoryLevel2={categoryLevel2}
                    isHeader={isHeader}
                />
            )}
        </li>
    );
}

export default SidebarCategoryLevel2Item;
